import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import hero1 from "../../Assets/hero1.jpeg";
import hero2 from "../../Assets/hero2.jpeg";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function Home2() {
  return (
    <Container fluid className="home-about-section about-stacked-section" id="learn-about">
      <TabWindow
        activeTabId="about"
        activeFileName="about_me.js"
        activeIcon="📁"
        language="JAVASCRIPT"
        lineCount="75"
      >
        <Row className="align-items-center">

          {/* Left: Heading + Bio */}
          <Col lg={7} md={12} className="home-about-description">
            <div className="terminal-container">

              <h1 className="about-heading">
                <TypeWriter text="Learn " speed={70} cursor={false} />
                <TypeWriter text="About me" speed={70} className="about-heading-accent" />
              </h1>

              <p className="about-role-tag">
                <TypeWriter text="AI/ML Engineer & Full-Stack Developer" speed={35} cursor={false} />
              </p>

              <div className="terminal-greet" style={{ marginTop: "18px" }}>
                <span className="terminal-prompt-symbol">&gt;&nbsp;</span>
                <TypeWriter
                  text="INITIALIZING_DATA_STREAM..."
                  speed={40}
                  className="terminal-func init-text"
                />
              </div>

              <p className="terminal-bio">
                I build things that ship. Currently an <strong className="purple">AI/ML Intern at DEBEL (DRDO)</strong>, designing deep-learning transformer models for real-time gait-phase analysis, and a <strong className="purple">B.E. AI &amp; ML undergraduate at DSCE</strong> with a <strong className="purple">9.08/10</strong> CGPA. At DigitalOrbit, I've architected and shipped <strong className="purple">15+ production applications</strong> for real clients — and I mentor the next wave of developers in Full Stack, ML, and DSA at Jain Group of Institutions.
              </p>

              <p className="terminal-bio">
                I don't just compete — I win. <strong className="purple">10+ national hackathon wins and finals</strong>, including Srujana 2025, AI Verse, and IIT Hyderabad DevDuel, plus a run as Tech Lead for Aventus 3.0 and judge for IdeaHive 3.0. Off the clock, I'm a trained <strong className="purple">Bharatanatyam dancer</strong>, a <strong className="purple">district-level throwball player</strong>, and the <strong className="purple">Cultural Head</strong> for the AI &amp; ML Department at DSCE — building a life is just as important as building software.
              </p>

            </div>
          </Col>

          {/* Right: Stacked Photos with browser frames */}
          <Col lg={5} md={12} className="home-about-avatar-col">
            <div className="stacked-photos-container">
              <div className="stacked-photo stacked-photo-back">
                <div className="photo-frame-header">
                  <span className="frame-dot dot-black"></span>
                  <span className="frame-dot dot-black"></span>
                  <span className="frame-dot dot-black"></span>
                </div>
                <img src={hero1} alt="Khushbu hero 1" className="stacked-photo-img" />
              </div>
              <div className="stacked-photo stacked-photo-front">
                <div className="photo-frame-header">
                  <span className="frame-dot dot-black"></span>
                  <span className="frame-dot dot-black"></span>
                  <span className="frame-dot dot-black"></span>
                </div>
                <img src={hero2} alt="Khushbu hero 2" className="stacked-photo-img" />
              </div>
            </div>
          </Col>

        </Row>
      </TabWindow>
    </Container>
  );
}

export default Home2;
